import React, { ReactNode } from "react";

import { EventTeamsInfoCore } from "@features/offer/shared/event/details";
import { EventOffer } from "@gp/offer";
import { OfferStore } from "@state/context/offer/OfferContext";
import { useOfferContext } from "@state/hooks/offer/useOfferContext";
import { observer } from "mobx-react";

export const EventTeamsInfo = observer(function EventTeamsInfo({
	event,
	children,
}: {
	event: EventOffer;
	children: ReactNode;
}) {
	const store = useOfferContext<OfferStore.EventViewStore>();
	return (
		<EventTeamsInfoCore store={store} event={event}>
			{children}
		</EventTeamsInfoCore>
	);
});
